<template>
  <DateSwiper v-model="currentDate">
    <Container class="PageCares">
      <ItemList
        :items="cares"
        :isLoading="isLoading"
        :getKeyFn="(o) => o.id"
        v-slot="{item}"
        emptyMessage="この日のお世話はありません"
      >
        <CareItem :care="item" :child="child" />
      </ItemList>
    </Container>
  </DateSwiper>
</template>

<script>
import CareItem from '@/components/organisms/CareItem'
import Container from '@/components/atoms/Container'
import DateSwiper from '@/components/molecules/DateSwiper'
import ItemList from '@/components/molecules/ItemList'

import moment from 'moment'
import FirebaseCares from '@/firebase/cares.ts'
const firebaseCares = new FirebaseCares()

export default {
  name: 'PageCares',
  layout: 'app',
  components: {
    CareItem,
    Container,
    DateSwiper,
    ItemList,
  },
  props: {
    child: {}
  },
  watch: {
    child: {
      handler: 'subscribeCares',
      immediate: true,
    },
    currentDate: {
      handler: 'subscribeCares',
      immediate: true,
    },
  },
  data() {
    return {
      cares: [],
      currentDate: new moment(),
      isLoading: true,
      unsubscribeListenCares: function() {},
    }
  },
  methods: {
    subscribeCares() {
      this.isLoading = true
      this.unsubscribeListenCares()
      const caredAtFrom = this.currentDate.clone().startOf('day')
      const caredAtTo = this.currentDate.clone().endOf('day')
      const callback = (cares) => {
        this.cares = cares
        this.isLoading = false
      }
      const filter = {
        caredAtFrom,
        caredAtTo,
      }
      this.unsubscribeListenCares = firebaseCares.getCaresRealtime(callback, this.child.id, filter)
    },
  },
  beforeRouteLeave(_1, _2, next) {
    this.unsubscribeListenCares()
    next()
  },
}
</script>

<style scoped lang="scss">
.PageCares {}
</style>
